import { OktaAuth, OAuthResponseMode } from '@okta/okta-auth-js'

const oktaConfig = {
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI,
  postLogoutRedirectUri: import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: import.meta.env.DEV, // Only for development
  // Use query mode for SPA callback
  responseMode: 'query' as OAuthResponseMode,
}

export const oktaAuth = new OktaAuth(oktaConfig)

export default oktaConfig
